<div class="table-content">
  <nz-table
    nzSize="small"
    [nzData]="rows"
    nzTableLayout="auto"
    nzShowPagination
    nzShowSizeChanger
    [nzLoading]="isLoading"
    [nzSize]="'middle'"
    [nzFrontPagination]="true"
    [nzTotal]="totalCount!"
    [nzOuterBordered]="true"
    [nzPageSizeOptions]="supportedPageSizes"
    [nzNoResult]="noResultTemplate"
    [nzHideOnSinglePage]="false"
    #borderedTable
    nzBordered
  >
    <thead>
      <tr>
        <th
          *ngFor="let cell of headers; index as i"
          [nzSortOrder]="cell.sortOrder"
          [nzSortFn]="cell.sortFn"
          [nzSortDirections]="cell.sortDirections"
          [nzFilterMultiple]="cell.filterMultiple"
          [nzFilters]="cell.listOfFilter"
          [nzFilterFn]="cell.filterFn"
        >
          {{ cell.name }}
          <nz-filter-trigger
            *ngIf="i === 1"
            [(nzVisible)]="visible"
            [nzActive]="searchValue.length > 0"
            [nzDropdownMenu]="menu"
          >
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of borderedTable.data">
        <td>{{ data.key }}</td>
        <td>
          {{ data.lastModified | dateTime }}
        </td>
        <td>
          {{ data.size | fileSize }}
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search name" [(ngModel)]="searchValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
    </div>
  </div>
</nz-dropdown-menu>

<ng-template #noResultTemplate let-name>
  <div>
    <span nz-icon nzType="file-sync" nzTheme="outline"></span>
    <p>No records available</p>
  </div>
</ng-template>
